import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {
  bootstrapLocalStorageEncryptionFromMsal,
  installLocalStorageEncryptionShim,
} from './app/shared/utility/local-storage-shim.util';
import {
  initNewRelicBrowser,
  NewRelicBrowserConfig,
} from './app/core/telemetry/newrelic-browser';

//if (environment.production) {
//  enableProdMode();
//}

// Step 1 — Connect encryption to localStorage and sessionStorage before app starts.
// After this line, every save/read in the app automatically encrypts and decrypts data.
installLocalStorageEncryptionShim();
initNewRelicBrowser(
  (environment as { newRelicBrowser?: NewRelicBrowserConfig }).newRelicBrowser
);

// Step 2 — If user already logged in (page refresh), create secret password from Microsoft login.
// Step 3 — Then start Angular app.
void bootstrapLocalStorageEncryptionFromMsal()
  .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
  .catch(err => console.error(err));
